// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ee616ed","239":"11a06437","455":"de955f3c"}[chunkId] + ".chunk.js";
};